import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) =>
  augmentColor({ color: { main: mainColor } });

export const paletteDataDarkMode = {
  infolight: createColor("rgba(105, 194, 227, 1)"),
  common: {
    black: "#000",
    white: "#fff",
  },
  primary: {
    main: "rgba(25, 27, 32, 1)",
  },
  secondary: {
    main: "rgba(187, 137, 127, 1)",
  },
  tertiary: {
    main: "rgba(107, 64, 56, 1)",
  },
  error: {
    main: "rgba(237, 76, 92, 1)",
  },
  warning: {
    // main: "rgba(231, 187, 65, 1)",
    main: "rgb(248, 150, 34, 1)",
  },
  success: {
    main: "rgba(39, 181, 109, 1)",
  },
  info: {
    main: "rgba(0, 156, 214, 1)",
  },
  white: {
    main: "rgba(255, 255, 255, 1)",
  },
  black: {
    main: "rgba(0, 0, 0, 1)",
  },
  lightgrey: {
    main: "rgb(82, 89, 105, 0.5)",
  },
  grey: {
    50: grey[50],
    100: grey[100],
    200: grey[200],
    300: grey[300],
    500: grey[500],
    600: grey[600],
    700: grey[700],
    800: grey[800],
    900: grey[900],
  },
  text: {
    primary: "rgba(255, 255, 255, 1)",
    secondary: "rgba(88, 94, 105, 1)",
    disabled: "rgba(255, 255, 255, 0.75)",
    danger: "rgba(213, 76, 90, 1)",
    lightGray: "rgba(187, 187, 187, 1)",
    tableheader: "rgba(171, 171, 171, 1)",
    formlink: "rgba(151, 158, 178, 1)",
  },
  background: {
    paper: "rgba(41, 43, 47, 1)",
    default: "rgba(41, 43, 47, 1)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
  divider: "rgba(245, 255, 250, 0.08)",
};

export const paletteDataLightMode = {
  infolight: createColor("rgba(105, 194, 227, 1)"),
  common: {
    black: "#000",
    white: "#fff",
  },
  primary: {
    main: "rgba(241, 241, 241, 1)",
  },
  secondary: {
    main: "rgba(187, 137, 127, 1)",
  },
  tertiary: {
    main: "rgba(234, 218, 215, 1)",
  },
  error: {
    main: "rgba(237, 76, 92, 1)",
  },
  warning: {
    // main: "rgba(231, 187, 65, 1)",
    main: "rgb(248, 150, 34, 1)",
  },
  success: {
    main: "rgba(39, 181, 109, 1)",
  },
  info: {
    main: "rgba(0, 156, 214, 1)",
  },
  white: {
    main: "rgba(255, 255, 255, 1)",
  },
  black: {
    main: "rgba(0, 0, 0, 1)",
  },
  lightgrey: {
    main: "rgb(82, 89, 105, 0.5)",
  },
  grey: {
    50: grey[50],
    100: grey[100],
    200: grey[200],
    300: grey[300],
    500: grey[500],
    600: grey[600],
    700: grey[700],
    800: grey[800],
    900: grey[900],
  },
  text: {
    primary: "rgba(25, 31, 44, 1)",
    secondary: "rgba(2, 2, 2, 1)",
    disabled: "rgba(88, 94, 105, 1)",
    danger: "rgba(213, 76, 90, 1)",
    lightGray: "rgba(187, 187, 187, 1)",
    tableheader: "rgba(88, 94, 105, 0.75)",
    formlink: "rgba(151, 158, 178, 1)",
  },
  background: {
    paper: "rgba(247, 247, 247, 1)",
    default: "rgba(247, 247, 247, 1)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
  divider: "rgba(105, 105, 105, 0.25)",
};
